// Theme runtime: fetches /api/settings/theme on app boot and sets
// :root CSS variables. Falls back gracefully if the request fails.
import { api } from "./api";

export const DEFAULT_THEME = {
  primary: "#0055FF",
  primary_hover: "#0044CC",
  accent: "#6366F1",
  success: "#16A34A",
  danger: "#E11D48",
  warning: "#D97706",
};

const VAR_MAP = {
  primary: "--sms-primary",
  primary_hover: "--sms-primary-hover",
  accent: "--sms-accent",
  success: "--sms-success",
  danger: "--sms-danger",
  warning: "--sms-warning",
};

export function applyTheme(theme) {
  const root = document.documentElement;
  Object.entries(VAR_MAP).forEach(([key, cssVar]) => {
    if (theme && theme[key]) root.style.setProperty(cssVar, theme[key]);
  });
}

export async function loadAndApplyTheme() {
  try {
    const { data } = await api.get("/settings/theme");
    applyTheme(data);
    return data;
  } catch {
    applyTheme(DEFAULT_THEME);
    return DEFAULT_THEME;
  }
}
